import { PaletteColor } from "@mui/material/styles";

export const blue: PaletteColor = {
  light: "#196ae7",
  main: "#005ae5",
  dark: "#0048b7",
  contrastText: "#ffffff",
};

export const orange: PaletteColor = {
  light: "#ffc04c",
  main: "#ffa500",
  dark: "#e59400",
  contrastText: "#4c3100",
};
